module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-3-blue.svg";